import { Box, Avatar, Typography, FormControl, InputLabel, MenuItem, Select, Card, Badge } from "@mui/material";
import { Cancel as CancelIcon, CheckCircle as CheckCircleIcon } from "@mui/icons-material";
import { colors, roleColors } from "../../../ui/colors";
import { menuPropsModal } from "../../../../utils";
import { FlownectBadge } from "./FlownectBadge";
import { BaseModalComponent } from "../../../common/BaseModalComponent";
import { useSelector } from "react-redux";
import { InviteUserView } from "../InviteUser/view/InviteUserView";
import { SUPER_LIGHT_BORDER } from "./PersonalInformation";

export const ProfileHeader = ({ workforce, selectedRole, onRoleChange }) => {
  const { companies } = useSelector((state) => state.userState);
  const [company] = companies;

  const hasFlownectAccount = workforce?.userUid;

  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 3,
        border: `1px solid ${SUPER_LIGHT_BORDER}`,
        overflow: "visible",
        position: "relative",
        backgroundColor: "var(--fx-surface-base, #FFFFFF)",
      }}
    >
      {hasFlownectAccount ? (
        <FlownectBadge hasFlownectAccount />
      ) : (
        <BaseModalComponent
          defaultSizes={{ width: 500, height: 680 }}
          modalKey={`Invite-User-${workforce.uid}`}
          modalLabel={`Invite ${workforce.firstName} ${workforce.lastName}`}
          elementTrigger={<FlownectBadge />}
        >
          <InviteUserView company={company} workforce={workforce} />
        </BaseModalComponent>
      )}

      <Box sx={{ position: "relative", mt: -5, textAlign: "center", pb: 3 }}>
        <Badge
          overlap="circular"
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          badgeContent={
            hasFlownectAccount ? (
              <CheckCircleIcon sx={{ color: roleColors.residential[500], fontSize: 20 }} />
            ) : (
              <CancelIcon sx={{ color: colors.gray[400], fontSize: 20 }} />
            )
          }
        >
          <Avatar
            sx={{
              width: 100,
              height: 100,
              bgcolor: colors.gray[100],
              color: colors.gray[700],
              fontSize: "2.5rem",
              fontWeight: 600,
              border: `3px solid ${colors.orange.base}`,
              boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
            }}
            src={workforce.avatar}
          >
            {!workforce?.avatar && workforce?.firstName ? workforce?.firstName?.charAt(0).toUpperCase() : ""}
          </Avatar>
        </Badge>

        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            color: colors.gray[900],
            my: 1,
          }}
        >
          {workforce.alias}
        </Typography>

        <FormControl
          size="small"
          sx={{
            mt: 1,
            minWidth: 200,
            "& .MuiOutlinedInput-root": {
              borderRadius: 10,
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: colors.orange.base,
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: colors.orange.base,
                borderWidth: 1,
              },
            },
          }}
        >
          <InputLabel
            id="staff-type-label"
            sx={{
              color: "var(--fx-surface-texttertiary, #94A3B8)",
              fontWeight: 800,
              textTransform: "uppercase",
              fontSize: "0.8rem",
              "&.Mui-focused": { color: colors.orange.base },
            }}
          >
            Change Role
          </InputLabel>
          <Select
            MenuProps={menuPropsModal}
            labelId="staff-type-label"
            value={selectedRole}
            label="Change Role"
            onChange={(e) => onRoleChange(e.target.value)}
            sx={{ fontSize: "0.9rem", fontWeight: 500 }}
          >
            <MenuItem value="employee">Employee</MenuItem>
            <MenuItem value="contractor">Contractor</MenuItem>
            <MenuItem value="supervisor">Supervisor</MenuItem>
          </Select>
        </FormControl>
      </Box>
    </Card>
  );
};
